import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { CurrenciesService } from 'src/app/api/currencies.service';
import { Currency } from 'src/app/models/currency';
import { WebSocketService } from 'src/app/api/web-socket.service';
import { MetadataService } from 'src/app/api/metadata.service';
import { PriceChartDuration } from 'src/app/models/price-chart';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'crypto-prices',
  templateUrl: './crypto-prices.component.html',
  styleUrls: ['./crypto-prices.component.scss']
})
export class CryptoPricesComponent implements OnInit, OnChanges, OnDestroy {
  PriceChartDuration = PriceChartDuration;

  @Input() count: number = null;
  @Input() showHeader = true;
  @Input() showUpdateDate = true;
  @Output() update = new EventEmitter<Date>();

  loading = true;
  error = false;

  fiatCurrency: string;
  fiatCurrencies: Currency[];
  currencies: Currency[];
  duration = PriceChartDuration.OneDay;
  lastUpdateDate: Date;

  constructor(
    private  metadata: MetadataService,
    private currenciesService: CurrenciesService,
    private wss: WebSocketService
  ) { }

  ngOnInit() {
    this.wss.connect();
    this.getDefaultFiatCurrency();
    this.getFiatCurrencies();

  }

  ngOnChanges(changes: SimpleChanges) {
    const countChange = changes['count'];

    if (countChange && countChange.previousValue !== countChange.currentValue && !countChange.firstChange) {
      this.getCryptoCurrencies();
    }
  }

  getDefaultFiatCurrency() {
    this.metadata.userCurrency().subscribe(response => {
      this.setFiatCurrency(response);
    }, err => {
      this.setFiatCurrency(environment.currencies.defaultCurrency);
    });
  }

  getCryptoCurrencies() {
    this.loading = true;

    this.currenciesService.getCryptoWithSupportedBase(this.fiatCurrency).subscribe(response => {
      this.loading = false;
      this.currencies = this.count ? response.splice(0, this.count) : response;
    }, err => {
      this.loading = false;
    });
  }

  getFiatCurrencies() {
    this.currenciesService.getFiatWithoutUsd().subscribe(response => {
      this.fiatCurrencies = response;
    });
  }

  setFiatCurrency(currency: string) {
    this.fiatCurrency = currency;
    this.getCryptoCurrencies();
  }

  changeDuration(duration: PriceChartDuration) {
    this.duration = duration;
  }

  onDataChange() {
    this.lastUpdateDate = new Date();
    this.update.next(this.lastUpdateDate);
  }

  ngOnDestroy() {
    this.wss.disconnect();
  }
}
